import loMerge from 'lodash/merge';

import { TFunction } from '@lyearn/i18n';

import { AddCoverI18n } from './types';

export const IMAGE_LIST_OVERRIDES = {
  className: 'flex-1',
  listClassName: 'px-20 grid-cols-3 mt-20',
};

export const modalClasses = {
  paper: 'h-full',
};

export const getI18nLabels = (t: TFunction, i18nLabels?: AddCoverI18n) => {
  const DEFAULTS = {
    actionText: i18nLabels?.actionText ?? t('Common:Image.AddImage'),
    headerTitle: i18nLabels?.headerTitle ?? t('Common:Image.ChooseCoverImage'),
    searchPlaceholder: i18nLabels?.searchPlaceholder ?? t('Common:Image.SearchUnsplash'),
  };

  return loMerge(DEFAULTS, i18nLabels);
};
